// extracted by mini-css-extract-plugin
module.exports = {"fader":"EmailFader_fader__1bUQo"};